const contentful = require('contentful');
const config = {
  space: process.env.VUE_APP_SPACE_ID,
  accessToken: process.env.VUE_APP_ACCESSTOKEN,
};

export const createContentfulClient = () => contentful.createClient(config);
